export default {
  FETCH_NOTIFICATIONS: "FETCH_NOTIFICATIONS",
  READ_ALL_NOTIFICATIONS: "READ_ALL_NOTIFICATIONS",
};
